// extracted by mini-css-extract-plugin
export var button = "button-module--button--2MFHw";
export var buttonBlue = "button-module--button-blue--63qBv";
export var buttonDark = "button-module--button-dark--ywQxm";
export var buttonLime = "button-module--button-lime--oLvRs";
export var buttonOutline = "button-module--button-outline--vTx0Y";
export var buttonOutlineBlack = "button-module--button-outline-black--v4Dg4";
export var buttonOutlineBlue = "button-module--button-outline-blue--67wDX";
export var buttonOutlineDark = "button-module--button-outline-dark--92UrS";
export var buttonOutlineLime = "button-module--button-outline-lime--4tIuF";
export var buttonOutlineWhite = "button-module--button-outline-white--0UZYU";
export var buttonWithDownArrow = "button-module--button-with-down-arrow--iz626";
export var buttonWithRightArrow = "button-module--button-with-right-arrow--8lq5O";
export var flexed = "button-module--flexed--Irbh7";